import isSpeedyMeetingSetByTenant from './isSpeedyMeetingSetByTenant';
import getCalendarCloudSettings from '../selectors/getCalendarCloudSettings';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';

/**
 * Checks if we should update speedy meetings.
 * We need to update the settings if:
 * - they don't come as part of the sessiondata
 * - the settings are set by the tenant
 */
export default function shouldUpdateSpeedyMeetingSettings(): boolean {
    const calendarCloudSettings = getCalendarCloudSettings();
    const shortenEventScopeSetting = calendarCloudSettings.get(
        CalendarCloudSettingType.ShortenEventScope.toLowerCase()
    );
    const endShortEventsBySetting = calendarCloudSettings.get(
        CalendarCloudSettingType.EndShortEventsBy.toLowerCase()
    );
    const endLongEventsBySetting = calendarCloudSettings.get(
        CalendarCloudSettingType.EndLongEventsBy.toLowerCase()
    );

    if (
        shortenEventScopeSetting == null ||
        endShortEventsBySetting == null ||
        endLongEventsBySetting == null ||
        isSpeedyMeetingSetByTenant()
    ) {
        return true;
    }

    return false;
}
